/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

/*
 ================================================
 COLOR CONSTANTS
 ================================================
 */
interface ColorShape {
    [index: string]: string,
}

const colorConstants: ColorShape = {
    orange: "color-orange",
    white: "#ffffff",
    black: '#000000',
    "color-blue-1": "#009fe3",
    "color-blue-handels": "#005fa0",
    "color-blue-knab": "#003b5a",
    "color-blue-trio": "#00006b",
    "color-gray-2": "#808080",
    "color-gray-3": "#9a9a9a",
    "color-gray-4": "#cccccc",
    "color-gray-5": "#434b50",
    "color-gray-7": "#e4e4e4",
    "color-green-abn": "#00857a",
    "color-green-whatsapp": "#29A71A",
    "color-orange": "#f39320",
    "color-orange-asn": "#f0533d",
    "color-purple-sns": "#562772",
    "color-red-moneyou": "#d40d47",
    "color-red-regio": "#ca031a",
};
export const PLATFORM_BASE_COLOR = '#3a4044', PLATFORM_CONTRAST_COLOR = 'white';
export const constants: ColorShape = {
    ...colorConstants,
};

export const convertColor = (colorName: string) => {
    if (colorIsHex(colorName)) return colorName;
    else if (colorConstants.hasOwnProperty(colorName)) {
        if (colorIsHex(colorConstants[colorName])) return colorConstants[colorName];

        const converted = colorConstants[colorName];
        if (converted && converted.length) return colorConstants[converted];
    }
    return colorName;
};

export const colorIsHex = (colorName: string): boolean => /^#[A-Za-z\d]{6,7}$/.test(colorName);

export const colorIsWhite = (color: string): boolean => color === 'white' || /#fff(fff)?/.test(color);

/*
 ================================================
 KEY CODES
 ================================================
 */
export const ENTER_CODE = 'Enter', ESCAPE_CODE = 'Escape', ESCAPE_IE_CODE = 'Esc';

/*
================================================
CURRENCIES
================================================
*/

export const EUR = '\u20ac', DOLLAR = '\u0024', YEN = '\u00A5', POUND = '\u00A3';

/*
================================================
MONTHS
================================================
*/

export const months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september',
    'oktober', 'november', 'december'];